<template>
  <q-btn
    v-bind="btnPropsComputed"
    :class="btnProps?.class"
    @click.stop="showDialog"
  >
    <slot name="btn"></slot>
    <q-tooltip v-if="btnProps?.tooltip">
      {{ btnProps?.tooltip }}
    </q-tooltip>
  </q-btn>
  <q-dialog
    v-model="visible"
    v-bind="dialogPropsComputed"
    @hide="hideDialog"
  >
    <q-card
      class="modal-button-card flex-column overflow-hidden"
      :class="card_class"
    >
      <q-toolbar>
        <q-toolbar-title>
          {{ dialogPropsComputed?.title || btnPropsComputed?.label }}
        </q-toolbar-title>
        <q-btn
          flat
          dense
          icon="close"
          v-close-popup
        />
      </q-toolbar>
      <q-card-section class="flex-fill overflow-auto q-pa-none">
        <slot></slot>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Dark } from "quasar";

export default defineComponent({
  name: "BtnModal",
  components: {},
  props: {
    btnProps: Object,
    dialogProps: Object,
    dialogVisible: Boolean,
  },
  emits: ["update:dialog-visible", "hide"],
  data() {
    return {
      visible: this.dialogVisible,
    };
  },
  computed: {
    btnPropsComputed(): any {
      return {
        flat: true,
        noCaps: true,
        label: undefined,
        ...this.btnProps,
      };
    },
    dialogPropsComputed(): any {
      return {
        title: undefined,
        fullHeight: true,
        ...this.dialogProps,
      };
    },
    card_class() {
      return {
        "bg-white": !Dark.isActive,
        "bg-dark": Dark.isActive,
      };
    },
  },
  watch: {
    dialogVisible() {
      this.visible = this.dialogVisible;
    },
  },
  methods: {
    showDialog() {
      this.visible = !this.visible;
      this.$emit("update:dialog-visible", this.visible);
    },
    hideDialog() {
      this.$emit("hide");
      this.$emit("update:dialog-visible", this.visible);
    },
  },
});
</script>

<style lang="scss">
.modal-button-card {
  min-width: 350px;
}
</style>
